/**
 * Normalized IndexedDB schema for grind mode storage.
 * Replaces blob-based KV storage with proper tables for scalability.
 *
 * SCHEMA OVERVIEW
 * ---------------
 * - settings: global key-value (scalar settings only, no blobs)
 * - user_prefs: per-user key-value (tableSize, isSimpleMode, grindSession)
 * - play_list: one row per tournament (denormalized snapshot per row, bounded size)
 * - list_members: one row per (userId, listType, scheduleId) for skip/bustLate/hidden/removedBustLate
 */

export const DB_NAME = "grind-mode-db";
export const DB_VERSION = 1;

export const STORE_SETTINGS = "settings";
export const STORE_USER_PREFS = "user_prefs";
export const STORE_PLAY_LIST = "play_list";
export const STORE_LIST_MEMBERS = "list_members";

/** List types stored as ID-only memberships (no blob) */
export type ListMemberType = "skip" | "bustLate" | "hidden" | "removedBustLate";

/** Keys in settings store */
export const SETTING_KEYS = {
  tableZoom: "tableZoom",
  autoResizeTable: "autoResizeTable",
  timeMaxLate: "timeMaxLate",
  autoAddMaxLate: "autoAddMaxLate",
  refreshSchedules: "refreshSchedules",
  tourColumnsSaved: "tourColumnsSaved",
  hourGroupColumn: "hourGroupColumn",
  gridColumnState: "gridColumnState",
  currencyRatesCache: "currencyRatesCache",
} as const;

/** Keys in user_prefs store */
export const USER_PREF_KEYS = {
  tableSize: "tableSize",
  isSimpleMode: "isSimpleMode",
  grindSession: "grindSession",
} as const;

/** Row: settings store */
export interface SettingsRow {
  key: string;
  value: string;
}

/** Row: user_prefs store. Primary key: [userId, key] */
export interface UserPrefRow {
  userId: number;
  key: string;
  value: string;
}

/** Row: play_list store. One row per tournament. Primary key: [userId, scheduleId] */
export interface PlayListRow {
  userId: number;
  scheduleId: number;
  data: Record<string, unknown>;
  addedAt: number;
}

/** Row: list_members store. Primary key: [userId, listType, scheduleId] */
export interface ListMemberRow {
  userId: number;
  listType: ListMemberType;
  scheduleId: number;
}
